import React from 'react';
import { Card } from 'react-bootstrap';
import { MdHttp } from 'react-icons/md';
import { FaConnectdevelop } from 'react-icons/fa';
import { BsList } from 'react-icons/bs';

const DbSourceInfo = () => (
  <Card.Body className='text-left'>
    <div className='mb-4 d-flex'>
      <div className='pr-3'>
        <BsList color='#8A92A0' size='2rem' />
      </div>
      <div>
        <p className='helper-header'>Data source type </p>
        <p className='helper-content'>
          The type of data source you are configuring.
        </p>
      </div>
    </div>
    <div className='mb-4 d-flex'>
      <div className='pr-3'>
        <FaConnectdevelop color='#8A92A0' size='2rem' />
      </div>
      <div>
        <p className='helper-header'>Data source name </p>
        <p className='helper-content'>
          A user-defined alias for the S3 file source location. Must not include spaces.
        </p>
      </div>
    </div>
    <div className='d-flex'>
      <div className='pr-3'>
        <MdHttp color='#8A92A0' size='2rem' />
      </div>
      <div>
        <p className='helper-header'>S3 URI</p>
        <p className='helper-content'>
          The URI for the S3 bucket you'd like to connect to.
        </p>
      </div>
    </div>
  </Card.Body>
);

export default DbSourceInfo;